import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const LockLockedIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8.83486 10.6668C8.83473 11.1279 8.46124 11.5014 8.00021 11.5015C7.53906 11.5015 7.16498 11.128 7.16486 10.6668C7.16486 10.2056 7.53898 9.8315 8.00021 9.8315C8.46132 9.83162 8.83486 10.2057 8.83486 10.6668Z"
      fill="currentColor"
    />
    <path
      d="M13.5 7.99968C13.4998 7.5397 13.127 7.16685 12.667 7.16667H3.33301C2.87303 7.16685 2.50018 7.5397 2.5 7.99968V13.3337C2.50018 13.7936 2.87303 14.1665 3.33301 14.1667H12.667C13.127 14.1665 13.4998 13.7936 13.5 13.3337V7.99968ZM14.5 13.3337C14.4998 14.3459 13.6793 15.1665 12.667 15.1667H3.33301C2.32074 15.1665 1.50018 14.3459 1.5 13.3337V7.99968C1.50018 6.98742 2.32074 6.16685 3.33301 6.16667H12.667C13.6793 6.16685 14.4998 6.98742 14.5 7.99968V13.3337Z"
      fill="currentColor"
    />
    <path
      d="M10.8336 6.66634V4.66634C10.8336 3.91508 10.5347 3.19467 10.0036 2.66341C9.47222 2.13205 8.75111 1.83333 7.99966 1.83333C7.24834 1.83341 6.52801 2.13213 5.99673 2.66341C5.46546 3.19468 5.16674 3.91501 5.16666 4.66634V6.66634C5.16666 6.94248 4.9428 7.16634 4.66666 7.16634C4.39051 7.16634 4.16666 6.94248 4.16666 6.66634V4.66634C4.16674 3.64979 4.57089 2.67519 5.2897 1.95638C6.00852 1.23756 6.98312 0.833414 7.99966 0.833328C9.01633 0.833328 9.99171 1.23749 10.7106 1.95638C11.4293 2.67517 11.8336 3.64987 11.8336 4.66634V6.66634C11.8336 6.94237 11.6096 7.16616 11.3336 7.16634C11.0575 7.16634 10.8336 6.94248 10.8336 6.66634Z"
      fill="currentColor"
    />
  </svg>
);
